import _ from 'lodash';
import { ValueFilter, FacetGroup, Facet, SortBy, SingleSortOrder } from "../Core";

export class SearchBootstrapper {
	constructor($location, searchService) {
		this.searchService = searchService;
		this.location = $location;
	}

	bootstrap() {
		var hashParams = this.location.search();
		var filterParams = ["q", "page"];
		var sortBy;
		var sortOrder;
		_.each(hashParams, (value, key) => {
			if (key === "sortBy") {
				sortBy = value;
				return;
			}

			if (key === "sortOrder") {
				sortOrder = value;
				return;
			}

			if (filterParams.indexOf(key !== -1)) {
				this.createFilter(key, value);
				return;
			}

			this.createFacet(key, value);
		});

		if (!sortBy) {
			sortBy = 'relevance';
		}

		var order;
		if (sortOrder) {
			order = new SingleSortOrder();
			order.current = sortOrder;
		}

		let by = new SortBy({ id: 'sortBy', value: sortBy });
		this.searchService.setSort(by, order);

		this.searchService.query();
	}

	createFilter(key, value) {
		this.searchService.addFilter(new ValueFilter({ id: key, value: value }));
	}

	createFacet(key, value) {
		var group = new FacetGroup({id: key });
		_.each(value.split(','), function(facetValue) {
			var facet = new Facet({id: facetValue, selected: true });
			group.addFacet(facet);
		});

	}
}

SearchBootstrapper.$inject = ['$location', 'searchService'];

